import fetch from '../utils/fetch';
// 获取活动配置信息
export function getForApp(activityId) {
  return fetch.get(`/marketing//api/onePlusOneActivity/getForApp?activityId=${activityId}`);
}

// 获取活动配置信息
export function hasQualifiedForApp(params) {
  return fetch.post(`/marketing//api/onePlusOneActivity/hasQualifiedForApp`, params);
}
